import { Link } from "react-router-dom";
import { IMAGES } from "@/data/services";

export const About = () => (
  <section id="about" data-testid="about-section" className="py-16 md:py-28">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-10 items-center">
      <div>
        <p className="font-display uppercase text-xs font-medium tracking-[0.3em] text-slate-400">
          Mobile Detailing & Polishing
        </p>
        <h2 className="mt-4 font-display uppercase font-semibold text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-wide text-white">
          Who is <br />
          <span className="text-[#FF4311]">Brad's Mobile Detailing?</span>
        </h2>
        <p data-testid="about-copy" className="mt-6 text-sm md:text-base text-slate-300 leading-relaxed">
          Brad's Mobile Detailing is a mobile detailing service based in
          Charlotte, NC and surroundings. We are a fully-equipped mobile detailing service — we
          travel to the location of your choice with our own equipment, supplies, water and
          electricity. We cater to clients who enjoy the luxury of a detailing service without
          having to sacrifice convenience. Kick back, relax and enjoy the comfort of your home or
          office while we make your vehicle look beautiful again. We are currently detailing about
          60 cars and trucks every month.
        </p>
        <div data-testid="about-community" className="mt-6 border-l-2 border-[#EA0A0B] pl-5 py-1 flex flex-col sm:flex-row sm:items-center gap-5">
          <div>
            <p className="font-display uppercase text-xs tracking-[0.2em] text-[#FF4311]">Giving Back to the Community</p>
            <p className="mt-2 text-sm text-slate-300 leading-relaxed">
              We sponsor local youth football teams and coach Little League on the side. When you book
              with us, you're supporting a local small business that invests right back into the
              Charlotte community.
            </p>
          </div>
          <img
            src="/gallery/coach.jpg"
            alt="Brad coaching Little League — Brad's Mobile Detailing gives back to the community"
            data-testid="about-community-image"
            className="w-full sm:w-40 md:w-48 shrink-0 object-cover aspect-[3/4] max-h-56 border border-[#232329]"
          />
        </div>
        <Link
          to="/about-us"
          data-testid="about-learn-more-button"
          className="mt-8 inline-block bg-[#EA0A0B] hover:bg-[#C20A0B] text-white font-display uppercase tracking-[0.1em] text-sm px-10 py-4 transition-colors"
        >
          Learn More About Us
        </Link>
      </div>

      <div className="relative h-[420px] md:h-[540px]">
        <img
          src="/hero-poster.jpg"
          alt="1967 Ford Mustang Fastback — Brad's Mobile Detailing"
          data-testid="about-image-1"
          className="absolute right-0 top-0 w-[62%] h-[85%] object-cover"
        />
        <img
          src={IMAGES.about1}
          alt="Detailed white truck"
          data-testid="about-image-2"
          className="absolute left-0 bottom-0 w-[55%] h-[70%] object-cover border-8 border-[#0A0A0C]"
        />
      </div>
    </div>
  </section>
);
